import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface SearchResult {
  id: string;
  title: string;
  subtitle?: string;
  type: 'LEAD' | 'QUOTE' | 'DOSSIER' | 'OTHER';
  url: string;
}

@Injectable({
  providedIn: 'root'
})
export class OmnisearchService {
  private readonly http = inject(HttpClient);
  
  isOpen = signal(false);

  open() {
    this.isOpen.set(true);
  }

  close() {
    this.isOpen.set(false);
  }

  toggle() {
    this.isOpen.update(v => !v);
  }

  search(query: string): Observable<{ data: SearchResult[] }> {
    return this.http.get<{ data: SearchResult[] }>(`${environment.apiUrl}/search`, {
      params: { q: query }
    });
  }
}
